module.exports = __webpack_public_path__ + "c8f0dc55156db06f70687ee5c66f6305.jpg";